import { useEffect, useState } from "react";
import useSelector from "../../store/selector";
import { constant, loggerStore, multiDecryption } from "../../utils/utils";
import { useLocation, useNavigate } from "react-router";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "../../Style/Modules/udyamDetails.module.css";
import "../../Style/Theme/index.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Avatar,
  Box,
  Chip,
  Container,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import Header from "../common/Header";
import SubmitButton from "../common/SubmitButton";
import Backdrop from "../common/Backdrop";
import LoadingDots from "../Lottie/LoadingDots";
import { apis } from "../../services/apiService";
import configData from "../../Config";
import AlertPopup from "../common/AlertPopup";
import { encryptApiData } from "../../utils/apiEncryption";

const UdyamDetails = () => {
  const { setRecoilVal, getRecoilVal } = useSelector();
  const [loading, setLoading] = useState(false);
  let location = useLocation();
  const [showUdyamDetail, setShowUdyamDetail] = useState("");
  const [finalErr, setFinalErr] = useState("");
  const navigate = useNavigate();
  const checkUdyamDetails = async () => {
    let getPreUdyamDatafromRecoil = getRecoilVal(
      constant.atomsName.UDYAM_DETAILS
    );
    let decrypteddata = await multiDecryption(getPreUdyamDatafromRecoil);
    setShowUdyamDetail(
      JSON.parse(decrypteddata[location?.state?.udyamInputvalue])
    );
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const reqData = {
        aid: location.state.AppId,
        op: false,
        un: location?.state?.udyamInputvalue,
        show_details: false,
        karzaUdhyamDetailedResponse: showUdyamDetail,
      };

      let resp = await apis.postApi(
        configData.API_URL + "Udhyam/UdhyamDetailed",
        {
          request: encryptApiData(reqData),
        }
      );
      let result = await resp.json();
      if (resp.status === 200) {
        setLoading(false);
        let data = {
          AppId: location.state.AppId,
          anchor: location.state.anchor,
          program: location.state.program,
          source: location.state.source,
        };
        navigate("/upload-udhyam", { state: data });
        loggerStore(
          location?.state?.AppId,
          `AddUdyam API response for success on Final Submit= ${JSON.stringify(
            result
          )}`,
          "Information"
        );
      }
    } catch (error) {
      setLoading(false);
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
      loggerStore(
        location?.state?.AppId,
        `AddUdyam API response for catch on Final Submit= ${JSON.stringify(
          error
        )}`,
        "Information"
      );
    }
  };

  useEffect(() => {
    checkUdyamDetails();
  }, []);

  const handleClosedFunk = () => {
    setFinalErr("");
  };

  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Box
          component="form"
          noValidate
          id="singleGSTDetails"
          onSubmit={handleSubmit}
          // onSubmit={handleSubmit}
          autoComplete="off"
        >
          <Header showBar={true} step={4} />
          <Box component="GSTDetails" className={styles.udyamDetailsBox}>
            {/* <Box className={styles.udyamDetailsBox1}>
              <Stack direction="row" spacing={2}>
                <Avatar
                  alt="UserPhoto"
                  src={`data:image/png;base64,${showUdyamDetail?.result?.aadharPhoto}`}
                  sx={{
                    width: 100,
                    height: 100,
                    border: "4px solid #50E0FF",
                  }}
                />
              </Stack>
              <Typography className={styles.udyamDetailsTypo}>
                {showUdyamDetail?.result?.userName}
              </Typography>
            </Box> */}
            <Box className={styles.udyamDetailsBox2}>
              <Divider className="dividerbg_Th">
                <Chip
                  className={`${styles.udyamDetailsPaper}`}
                  icon={<AccountCircleIcon />}
                  sx={{ fontWeight: "bold" }}
                  label="USER DETAILS"
                />
              </Divider>
              <Paper className={styles.udyamDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Udyam Registration No
                </Typography>
                <Typography>
                  {showUdyamDetail?.result?.udyamRegistrationNo}
                </Typography>
              </Paper>
              <Paper className={styles.udyamDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Date Of Registration
                </Typography>
                <Typography>
                  {showUdyamDetail?.result?.dateOfRegistration}
                </Typography>
              </Paper>
              <Paper className={styles.udyamDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>Mobile</Typography>
                <Typography>
                  {showUdyamDetail?.result?.officialAddress?.mobile}
                </Typography>
              </Paper>
              {showUdyamDetail?.result?.profile?.emailId && (
                <Paper className={styles.udyamDetailsPaper}>
                  <Typography sx={{ fontWeight: "bold" }}>Mobile</Typography>
                  <Typography>
                    {showUdyamDetail?.result?.officialAddress?.mobile}
                  </Typography>
                </Paper>
              )}
              <Paper className={styles.udyamDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>Gender</Typography>
                <Typography>
                  {showUdyamDetail?.result?.profile?.gender}
                </Typography>
              </Paper>
            </Box>
            <Box className={styles.udyamDetailsBox2}>
              <Divider className="dividerbg_Th">
                <Chip
                  className={`${styles.udyamDetailsPaper}`}
                  icon={<BusinessCenterIcon />}
                  sx={{ fontWeight: "bold" }}
                  label="BUSINESS DETAILS"
                />
              </Divider>
              <Paper className={styles.udyamDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>Name</Typography>
                <Typography>
                  {showUdyamDetail?.result?.profile?.name}
                </Typography>
              </Paper>
              {showUdyamDetail?.result?.profile?.enterpriseType && (
                <Paper className={styles.udyamDetailsPaper}>
                  <Typography sx={{ fontWeight: "bold" }}>
                    Enterprise Type
                  </Typography>
                  <Typography>
                    {showUdyamDetail?.result?.profile?.enterpriseType}
                  </Typography>
                </Paper>
              )}
              <Paper className={styles.udyamDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Organization Type
                </Typography>
                <Typography>
                  {showUdyamDetail?.result?.profile?.organizationType}
                </Typography>
              </Paper>
              <Paper className={styles.udyamDetailsPaper1}>
                <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                  Official Address
                </Typography>
                <Typography>
                  {showUdyamDetail?.result?.officialAddress?.flat},{" "}
                  {showUdyamDetail?.result?.officialAddress?.block},{" "}
                  {showUdyamDetail?.result?.officialAddress?.village},{" "}
                  {showUdyamDetail?.result?.officialAddress?.road},{" "}
                  {showUdyamDetail?.result?.officialAddress?.premises},{" "}
                  {showUdyamDetail?.result?.officialAddress?.district},{" "}
                  {showUdyamDetail?.result?.officialAddress?.city},{" "}
                  {showUdyamDetail?.result?.officialAddress?.state}-
                  {showUdyamDetail?.result?.officialAddress?.pincode}
                </Typography>
                <Typography>
                  {" "}
                  {showUdyamDetail?.result?.officialAddress?.email}
                </Typography>
              </Paper>
              <Paper
                sx={{
                  mt: "5px",
                  p: 1,
                  mb: 15,
                }}
              >
                <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                  Branch Details
                </Typography>
                {showUdyamDetail?.result?.branchDetails.map(
                  (indexVal, index) => {
                    return (
                      <>
                        {showUdyamDetail?.result?.branchDetails.length > 1 &&
                          index !== 0 && <hr />}
                        <Typography sx={{ mb: 1 }}>
                          {indexVal?.name}, {indexVal?.flat}, {indexVal?.block},{" "}
                          {indexVal?.village}, {indexVal?.road},{" "}
                          {indexVal?.premises}, {indexVal?.district},{" "}
                          {indexVal?.city}, {indexVal?.state}-
                          {indexVal?.pincode}
                        </Typography>
                      </>
                    );
                  }
                )}
              </Paper>
            </Box>
          </Box>
          <SubmitButton hasNote="No" />
        </Box>
        {loading && (
          <Backdrop ax="center">
            <LoadingDots />
          </Backdrop>
        )}
        {finalErr && (
          <Backdrop ax="center">
            <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />;
          </Backdrop>
        )}
      </Container>
    </>
  );
};

export default UdyamDetails;
